module.exports = __webpack_public_path__ + "static/media/Nguyen_Viet_Huy.186fd755.jpg";